var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"StatusBadget phase-name"},[_c('b-badge',{attrs:{"variant":_vm.getVariant()}},[_vm._v(_vm._s(_vm.getText()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }